"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVisibilityToggle = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const createVisibilityToggle = ({ condition, isVisible, onClick, x, y, }) => {
    const buttonIDs = [];
    const spriteIDs = [];
    spriteIDs.push((0, pixel_pigeon_1.createSprite)({
        animationID: () => (typeof isVisible === "function" ? isVisible() : isVisible)
            ? "visible"
            : "hidden",
        animations: [
            {
                frames: [
                    {
                        height: 16,
                        sourceHeight: 16,
                        sourceWidth: 16,
                        sourceX: 0,
                        sourceY: 0,
                        width: 16,
                    },
                ],
                id: "visible",
            },
            {
                frames: [
                    {
                        height: 16,
                        sourceHeight: 16,
                        sourceWidth: 16,
                        sourceX: 16,
                        sourceY: 0,
                        width: 16,
                    },
                ],
                id: "hidden",
            },
        ],
        coordinates: {
            condition,
            x,
            y,
        },
        imagePath: "visibility-toggle",
    }));
    if (typeof onClick !== "undefined") {
        buttonIDs.push((0, pixel_pigeon_1.createButton)({
            coordinates: {
                x,
                y,
            },
            height: 16,
            onClick,
            width: 16,
        }));
    }
    return (0, pixel_pigeon_1.mergeHUDElementReferences)([
        {
            buttonIDs,
            spriteIDs,
        },
    ]);
};
exports.createVisibilityToggle = createVisibilityToggle;
